import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'

export const STEP_IDS = [
  'team',
  'roster',
  'events',
  'recruitment',
  'loot',
  'notifications',
  'access',
  'linked_guilds',
] as const

export const isSettingUpFirstTeam = (
  guild: Pick<wowaudit.Guild, 'teamReferences'> | undefined,
  createdTeamId: number | string | null | undefined,
) =>
  !!guild &&
  guild.teamReferences.every(
    (team) => String(team.id) === String(createdTeamId),
  )

export const useOnboardingSteps = (
  guild: Pick<wowaudit.Guild, 'teamReferences'> | undefined,
  createdTeamId: number | string | null | undefined,
) => {
  const gameVersion = useGameVersion()
  const isFirstTeam = isSettingUpFirstTeam(guild, createdTeamId)

  return STEP_IDS.filter((id) => {
    if (id === 'loot') return gameVersion.has('loot')
    if (id === 'roster') return gameVersion.has('blizzard_api')
    if (id === 'linked_guilds') {
      return gameVersion.has('linked_guilds_onboarding') && isFirstTeam
    }
    return true
  })
}
